import { render, staticRenderFns } from "./AgreementCard.vue?vue&type=template&id=0b2a5d6a&"
import script from "./AgreementCard.vue?vue&type=script&lang=js&"
export * from "./AgreementCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports